import React from 'react';
import { Alert, Space } from '@ally/metronome-ui';
import styled, { css } from 'styled-components';
const StyledAlert = styled(Alert)(({ theme: { space } }) => css `
    margin-top: ${space.md};
  `);
export default function OutageNotice({ bankStatus, investStatus, isBank, isInvest, isWealthClient, wealthStatus, }) {
    const shouldRender = (isBank && bankStatus === 'down') ||
        (isInvest && investStatus === 'down') ||
        (isWealthClient && wealthStatus === 'down');
    if (!shouldRender) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Space, { pb: "lg" },
        React.createElement(StyledAlert, { variant: "error", heading: "Some of our features aren\u2019t available right now. We\u2019ll have things back up as soon as possible. Thanks for your patience. If you need help in the meantime, you can always call us." })));
}
//# sourceMappingURL=OutageNotice.js.map